import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private snackbar: MatSnackBar) {}

  error(errorMessage, action = 'OK', duration = 3000) {
    this.snackbar.open(errorMessage, action, {
      duration,
    });
  }

  success(successMessage, action = 'OK', duration = 3000) {
    this.snackbar.open(successMessage, action, {
      duration,
    });
  }

  /**
   * New Desktop notification if permission is granted
   * @param title
   * Notification Title
   * @param body
   * Notification Body
   */
  desktopNotification(title: string, body?: string) {
    if (Notification.permission === 'granted') {
      const notification = new Notification(title, {
        body,
      });
    }
  }
}
